import React, { Component } from "react";
import { Menu, MenuButton, MenuList, MenuItem, Button, ButtonGroup, Center } from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faSyncAlt,  faImages, faStar, faXmarkCircle, faPhotoFilm, faMapLocation, faIcicles, faFileUpload, faGraduationCap} from "@fortawesome/free-solid-svg-icons";
import { ChevronDownIcon } from "@chakra-ui/icons";

import RoleManager from "../../../models/RoleManager";
import { AppSecurityKey } from "../../../models/AppSecurityKey";
import { ObservationSessionMode } from "../../../models/ObservationSessionMode";





export default class FooterButtonStrip extends Component 
{
  constructor(props) {
    super(props);

    this.state = {

    }; 

    this.onConfirmCancel = this.onConfirmCancel.bind(this);

  }

  async componentDidUpdate(prevProps, prevState)
  {
    /*
    if (this.props.searchParamsKey !== prevProps.searchParamsKey)
    {

    }
    */
  }

  onConfirmCancel()
  {
    this.props.onMsgBoxRequest("Quit Observation", 'Are you sure you want to quit this observation? It will not be saved.', '', 'question', 'Yes-Quit', this.props.onCloseRequest, 'Return to Observation' );
  }

  render() 
  {

    const loadingIcon = (this.props.isLoading || this.props.isSaving) ? 
        <FontAwesomeIcon icon={faSyncAlt} color="green" spin />
       : <span/>;

    const isReadOnly = (this.props.observationSessionMode === ObservationSessionMode.READONLY);

    const showDebugButton = ((this.props.userSession) && (RoleManager.hasRoleRights(AppSecurityKey.DEBUG_OBSERVATION, this.props.userSession.token)));
    const showPreviewScoreButton = ((this.props.userSession) && (RoleManager.hasRoleRights(AppSecurityKey.PREVIEW_OBSERVATION_SCORE, this.props.userSession.token )));
    return (
        <Center >
           {loadingIcon}


           {(!isReadOnly) &&
            <Button
              variant="solid"
              leftIcon={<FontAwesomeIcon icon={faStar} />}
              bg='#0095c8'
              color='white'
              fontSize={{ base: '12px', md: '14px', lg: '18px' }}
              onClick={this.props.onSaveRequest}
              marginRight='5vw'
            >
              score
            </Button>
          }

        <ButtonGroup isAttached>



          {(!isReadOnly) &&
            <Button
              variant="solid"
              leftIcon={<FontAwesomeIcon icon={faIcicles} />}
              bg='#0095c8'
              color='white'
              fontSize={{ base: '12px', md: '14px', lg: '18px' }}
              onClick={this.props.onSuspendRequest}
            >
              suspend
            </Button>
          }
        
        {(!isReadOnly) &&
            <Button
              variant="solid"
              leftIcon={<FontAwesomeIcon icon={faXmarkCircle} />}
              bg='#0095c8'
              color='white'
              fontSize={{ base: '12px', md: '14px', lg: '18px' }}
              onClick={this.onConfirmCancel}
            >
           cancel
            </Button>
        }  


        {(isReadOnly) &&
            <Button
              variant="solid"
              leftIcon={<FontAwesomeIcon icon={faXmarkCircle} />}
                      bg='#0095c8'
                      color='white'
                      fontSize={{ base: '12px', md: '14px', lg: '18px' }}
                      onClick={(e) => this.props.onCloseRequest(false)}
                    >
                    close
            </Button>  
          }


        {(!isReadOnly) &&
          <Menu >
            <MenuButton
              id="imageDocsButton"
              as={Button}
              leftIcon={<FontAwesomeIcon icon={faImages} />}
              rightIcon={<ChevronDownIcon />}
              bg='#0095c8'
              color='white'
              fontSize={{ base: '12px', md: '14px', lg: '18px' }}
            >
            images/docs
            </MenuButton>
            <MenuList>
              <MenuItem id="gcidSlides" icon={<FontAwesomeIcon icon={faImages} />} onClick={() => this.props.onViewSlidesRequest()} >slides</MenuItem>
              <MenuItem id="userImages" icon={<FontAwesomeIcon icon={faPhotoFilm} />} onClick={() => this.props.onViewUserImagesRequest()} >images</MenuItem>
              <MenuItem id="userImages" icon={<FontAwesomeIcon icon={faFileUpload} />} onClick={() => this.props.onShowUserFiles(true)} >files</MenuItem>
            </MenuList>
          </Menu>
        }


          
          {/*(!isReadOnly) &&
            <Button
              variant="solid"
              leftIcon={<FontAwesomeIcon icon={faImages} />}
              bg='#0095c8'
              color='white'
              fontSize={{ base: '12px', md: '14px', lg: '18px' }}
              onClick={this.props.onViewSlidesRequest}
            >
             slides
            </Button>
          */}


          {/*(!isReadOnly) &&
            <Button
              variant="solid"
              leftIcon={<FontAwesomeIcon icon={faPhotoFilm} />}
              bg='#0095c8'
              color='white'
              fontSize={{ base: '12px', md: '14px', lg: '18px' }}
              onClick={this.props.onViewUserImagesRequest}
            >
             images
            </Button>
          */}

          {/*(!isReadOnly) &&
            <Button
              variant="solid"
              leftIcon={<FontAwesomeIcon icon={faFileUpload} />}
              bg='#0095c8'
              color='white'
              fontSize={{ base: '12px', md: '14px', lg: '18px' }}
              onClick={(e) => this.props.onShowUserFiles(true)}
            >
             files
            </Button>
          */}





        {(!isReadOnly) &&
          <Menu >
            <MenuButton
              id="adminButton"
              as={Button}
              leftIcon={<FontAwesomeIcon icon={faGraduationCap} />}
              rightIcon={<ChevronDownIcon />}
              bg='#0095c8'
              color='white'
              fontSize={{ base: '12px', md: '14px', lg: '18px' }}
            >
            admin
            </MenuButton>
            <MenuList>
              {(showPreviewScoreButton) &&
                <MenuItem id="previewScore" icon={<FontAwesomeIcon icon={faMapLocation} />} onClick={(e) => this.props.onPreviewScoreRequest(e)} >preview score</MenuItem>
              }
              {(showDebugButton) &&
                <MenuItem id="showDebugInfo" icon={<FontAwesomeIcon icon={faMapLocation} />} onClick={(e) => this.props.onToggleDebugRequest(e)} >toggle debug info</MenuItem>
              }
              <MenuItem id="refreshEnviron" icon={<FontAwesomeIcon icon={faGraduationCap} />} onClick={(e) => this.props.onRefreshEnvironRequest(e)} >refresh environ</MenuItem>
            </MenuList>
          </Menu>
        }


          {/*(showPreviewScoreButton) && 
            <Button
              variant="solid"
              leftIcon={<FontAwesomeIcon icon={faMapLocation} />}
              bg='#0095c8'
              color='white'
              fontSize={{ base: '12px', md: '14px', lg: '18px' }}
              onClick={(e) => this.props.onPreviewScoreRequest(e)}
            >
            Preview Score
            </Button>
          */}




          {/*(!isReadOnly) &&
            <Button
              variant="solid"
              leftIcon={<FontAwesomeIcon icon={faGraduationCap} />}
              bg='#0095c8'
              color='white'
              fontSize={{ base: '12px', md: '14px', lg: '18px' }}
              onClick={(e) => this.props.onRefreshEnvironRequest(e)}
            >
            refresh environ
            </Button>
          */}
            

            {/*(showDebugButton) &&
            <Button
              variant="solid"
              leftIcon={<FontAwesomeIcon icon={faMapLocation} />}
              bg='#0095c8'
              color='white'
              fontSize={{ base: '12px', md: '14px', lg: '18px' }}
              onClick={(e) => this.props.onToggleDebugRequest(e)}
            >
            Toggle Debug Info
            </Button>
            */}

        </ButtonGroup>



  </Center>


    );
  }
}
